export function formatTimeStamp(timestamp) {
  const date = new Date(timestamp);
  const now = new Date();

  // Helper to check if two dates are on the same day
  const isSameDay = (d1, d2) =>
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate();

  // Format the time in 12-hour format
  const formatTime = (d) => {
    let hours = d.getHours();
    const minutes = d.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    const minutesStr = minutes < 10 ? `0${minutes}` : minutes;
    return `${hours}:${minutesStr} ${ampm}`;
  };

  // Check if date is today
  if (isSameDay(date, now)) {
    return `${formatTime(date)}`;
  }

  // Check if date is yesterday
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (isSameDay(date, yesterday)) {
    return `Yesterday, ${formatTime(date)}`;
  }

  // Options for formatting date
  const optionsCurrentYear = { month: "short", day: "numeric" };
  const optionsOtherYear = { month: "short", day: "numeric", year: "numeric" };

  if (date.getFullYear() === now.getFullYear()) {
    const dateStr = date.toLocaleDateString(undefined, optionsCurrentYear);
    return `${dateStr}, ${formatTime(date)}`;
  } else {
    const dateStr = date.toLocaleDateString(undefined, optionsOtherYear);
    return `${dateStr}, ${formatTime(date)}`;
  }
}

export const formatTimeStampToDay = (timestamp) => {
  const date = new Date(timestamp);
  const now = new Date();

  // Helper: reset a date to just its year/month/day
  const resetToMidnight = (d) =>
    new Date(d.getFullYear(), d.getMonth(), d.getDate());

  const today = resetToMidnight(now);
  const givenDay = resetToMidnight(date);

  // 1. If it's today, return the time in 12-hour format
  if (today.getTime() === givenDay.getTime()) {
    // Format time in 12-hour with hour and minute.
    return date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
    });
  }

  // 2. If it's yesterday, return "Yesterday"
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  if (givenDay.getTime() === yesterday.getTime()) {
    return "Yesterday";
  }

  // 3. If it's within the last 6 days, return the day name.
  const sixDaysAgo = new Date(today);
  sixDaysAgo.setDate(today.getDate() - 6);
  if (givenDay >= sixDaysAgo) {
    return date.toLocaleDateString("en-US", { weekday: "long" });
  }

  // 4. If it's from this year, return date and month (e.g. "23 Jan")
  if (date.getFullYear() === now.getFullYear()) {
    return date.toLocaleDateString("en-US", { day: "numeric", month: "short" });
  }

  // 5. Otherwise return day, month, and year (e.g. "23 Jan 2020")
  return date.toLocaleDateString("en-US", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};

// Helper function to format timestamp in US format.
export const formatTimestampInDateAndTime = (timestamp) => {
  const date = new Date(timestamp);
  return date.toLocaleString("en-US", {
    year: "numeric",
    month: "short", // or "long" for full month name like "April"
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true, // For 12-hour format with AM/PM
  });
};

// Helper function to format date for WhatsApp-like display
export const formatDateForChatHeader = (date) => {
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  const messageDate = new Date(date);

  if (messageDate.toDateString() === today.toDateString()) {
    return "Today";
  } else if (messageDate.toDateString() === yesterday.toDateString()) {
    return "Yesterday";
  } else {
    // Show year only if it's not current year
    const isCurrentYear = messageDate.getFullYear() === today.getFullYear();

    if (isCurrentYear) {
      return messageDate.toLocaleDateString("en-US", {
        weekday: "short",
        month: "short",
        day: "numeric",
      });
    } else {
      return messageDate.toLocaleDateString("en-US", {
        weekday: "short",
        month: "short",
        day: "numeric",
        year: "numeric",
      });
    }
  }
};

// Helper function to format time only
export const formatTimeOnly = (date) => {
  const messageDate = new Date(date);
  const hours = messageDate.getHours();
  const minutes = messageDate.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";
  const displayHours = hours % 12 || 12;
  const displayMinutes = minutes < 10 ? `0${minutes}` : minutes;
  return `${displayHours}:${displayMinutes} ${ampm}`;
};
